import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Loader from '../../../shared/component/Loader';

const AllTemplates = ({ module, refs, templateList, templateRefs }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [thumbnails, setThumbnails] = useState({});

  const handleInsertTemplate = () => {
    navigate('/settings/templateGallery/newTemplate', {
      state: { module: module },
    });
  };
  const handleSelectTemplate = (data) => {
    const updatedData = { ...data, type: 'add' };
    navigate('/settings/templateGallery/newTemplate', {
      state: { module: module, data: updatedData },
    });
  };

  return (
    <>
      {loading && <Loader />}
      <div className="rightheader">
        <div className="tempHdr">
          <div className="dropdown">
            <p className="pb-0">{module}</p>
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <li>
                <Link className="dropdown-item" to="#">
                  Action
                </Link>
              </li>
              <li>
                <Link className="dropdown-item" to="#">
                  Another action
                </Link>
              </li>
              <li>
                <Link className="dropdown-item" to="#">
                  Something else here
                </Link>
              </li>
            </ul>
          </div>
          <button className="btn btn-primary" onClick={handleInsertTemplate}>
            {' '}
            New Blank Template
          </button>
        </div>
      </div>
      <div className="rightContent">
        {templateList.length > 0 ? (
          templateList.map((data, index) => (
            <div
              key={data.templateType + '-' + index}
              ref={templateRefs?.current?.[data.templateType.replace(/\s+/g, '').toLowerCase()]}
            >
              <div className="tblheader alltemaplateHeder">
                <h3>
                  {data.templateType}
                  <span className="tempNo">{data?.data?.length}</span>
                </h3>
              </div>
              <div className="templateBlk">
                {data?.data?.length > 0 &&
                  data?.data?.map((data) => (
                    <div key={data.id} className="tmpBox">
                      <div className="templateBlkInner">
                        <div className="hoverDiv">
                          <button
                            className="btn btn-primary selBtn"
                            onClick={() => handleSelectTemplate(data)}
                          >
                            Select
                          </button>
                        </div>
                        <img src="../assets/images/temp1.jpg" alt="" />
                      </div>
                      <p>{data.name}</p>
                    </div>
                  ))}
              </div>
            </div>
          ))
        ) : (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '60vh',
              textAlign: 'center',
            }}
          >
            <h3>No template found</h3>
          </div>
        )}
      </div>
    </>
  );
};

export default AllTemplates;
